export default __webpack_public_path__ + "static/media/left-side.daef17cd.png";